import { create, destroy, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { SlidingPane } from '@holmescorp/base-widgets/sliding-pane';
import { publish, subscribe } from 'pub-sub';
import { createNlsMiddleware, registry } from 'lcc-state';
import { delay } from '@holmescorp/common';
import { viewport } from '../support/viewport';
import { NewAnnouncements } from '@holmescorp/announcements';
const icache = createICacheMiddleware();
const nls = createNlsMiddleware('settings');
const factory = create({
    icache,
    nls,
    destroy
}).properties();
export const AnnouncementsPane = factory(({ properties, middleware: { icache, nls, destroy } }) => {
    icache.getOrSet('aboutToChange', false);
    const { openaction, onClose } = properties();
    const open = icache.getOrSet('open', () => {
        const hnd = [
            subscribe(openaction, async () => {
                icache.set('aboutToChange', true);
                await delay(200);
                icache.set('open', true);
            }),
            subscribe('close-all/panes', () => {
                icache.set('open', false);
            })
        ];
        destroy(() => hnd.forEach((h) => h.destroy()));
        return false;
    });
    const { vw } = viewport();
    const { messages: { announcements_title = '[settings] announcements_title' } } = nls();
    const xqa = `announcements-pane-${open}`;
    return [
        w(SlidingPane, {
            xqa,
            key: 'announcements-pane',
            open,
            align: 'right',
            underlay: true,
            title: announcements_title,
            width: Math.min(vw, 1024),
            onRequestClose: () => {
                icache.set('open', false);
                icache.set('aboutToChange', async () => {
                    await delay(500);
                    return true;
                });
                publish('notifications/change-status', { hasNewNotifications: false });
                onClose && onClose();
            }
        }, [w('Announcements', {})]),
        w(NewAnnouncements, {})
    ];
});
registry.define('AnnouncementsPane', AnnouncementsPane);
